import axios from 'axios'
// import localConfig from '@/config'
// import { message } from "ant-design-vue";

axios.interceptors.request.use(
  config => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const token = userInfo.token
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    config.baseURL = '/'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
// axios.interceptors.response.use(
//   function(response) {
//     // 对响应数据做点什么
//     if (response.data && response.data.code !== 0) {
//       message.error(response.data.message || "出错啦~");
//       return;
//     }
//     return response.data;
//   },
//   function(error) {
//     return Promise.reject(error);
//   }
// );

export default axios
